import { url } from '@/config';
import { aidaApiUrl } from '@/config';
import request from '../axios'
export const getList = (params) => request({
  // url: url + '/map/list',
  url: aidaApiUrl + '/aida-basic/basicConfig/pageList',
  method: 'get',
  params: params
});



export const getObj = (id) => request({
  // url: url + '/map/detail',
  url: aidaApiUrl + '/aida-basic/basicConfig/getById',
  method: 'get',
  params: {
    id
  }
});

export const getMapData = (url) => request({
  // url: url + '/map/detail',
  url: url,
  method: 'get',
});

export const addObj = (data) => request({
  // url: url + '/map/save',
  url: aidaApiUrl + '/aida-basic/basicConfig/add',
  method: 'post',
  data: data
});
export const updateObj = (data) => request({
  // url: url + '/map/update',
  url: aidaApiUrl + '/aida-engine/pageComponentTemplate/edit',
  method: 'post',
  data: data
});



export const delObj = (id) => request({
  // url: url + '/map/remove',
  url: aidaApiUrl + '/aida-basic/basicConfig/del',
  method: 'post',
  params: {
    ids: id
  }
});

export const getOrganizationList = (code) => request({
  // url: aidaApiUrl + '/aida-oacl/orgUnit/searchBySession',
  url: aidaApiUrl + '/aida-oacl/orgLevel/getHierarchyTreeByCode',
  method: 'get',
  params: {
    code,
  }
})